<div class="top-menu">
  <div><button title="About Us" mat-button>About Us</button></div>
  @if (isUserLoggedIn$ | async) {
    <div><button [title]="'common.past_donations' | translate" mat-button>{{"common.past_donations" | translate}}</button></div>
    @if (isUserLoggedIn$ | async) {
      <div>
        <!-- <button mat-button >LogOut</button> -->
        <button [title]="'aria.account' | translate" mat-icon-button [matMenuTriggerFor]="menu">
          <i class="far fa-user-circle btn-header-icon"></i>
        </button>
      </div>
    }
    <mat-menu #menu="matMenu" xPosition="before">
      <!-- <button mat-menu-item>Item 1</button>
      <button mat-menu-item>Item 2</button> -->
      <div class="flex-row-end">
        <button title="Sign out" mat-button class="sm-btn" (click)="logout()">Sign out</button>
      </div>
      <div class="flex-row">
        <div class="circle-container">
          <div class="numberCircle">AA</div>
        </div>
        <div class="profile-descriptions">
          <span> Anis Ali</span>
          <span>anis.ali&#64;protiviti.com</span>
          <button title="Settings" mat-icon-button routerLink="/donor/settings">
            <i class="fas fa-cog"></i>
            Settings
          </button>
        </div>
      </div>
    </mat-menu>
  }
  @if ((isUserLoggedIn$ | async) === false) {
    <div>
      <button title="Log In" mat-button routerLink="login">LogIn</button>
    </div>
  }

</div>
